import { render } from "./shop-sidebar-brands.vue?vue&type=template&id=34f1cf3b&scoped=true"
import script from "./shop-sidebar-brands.vue?vue&type=script&lang=js"
export * from "./shop-sidebar-brands.vue?vue&type=script&lang=js"

import "./shop-sidebar-brands.vue?vue&type=style&index=0&id=34f1cf3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f1cf3b"]])

export default __exports__